import { lazy } from 'react';

export const LandingPage = lazy(() => import('components/LandingPage'));

// New User Sign Up
export const SignUp = lazy(() =>
  import('components/Authentication/elements/SignUp')
);
export const UserMatching = lazy(() =>
  import('components/Authentication/elements/Matching')
);
export const MatchValidation = lazy(() =>
  import('components/Authentication/elements/Validation')
);
export const MagicLink = lazy(() =>
  import('components/Authentication/elements/MagicLink')
);
export const TermsOfUseAcceptancePage = lazy(() =>
  import('../components/Authentication/elements/TermsofUseAcceptancePage')
);
export const SignUpHelp = lazy(() =>
  import('components/Authentication/elements/Help')
);
export const ProfileExternalView = lazy(() =>
  import('../components/ProfileExternalView')
);

// Philanthropy
export const Philanthropy = lazy(() => import('../components/Philanthropy'));
export const GivingCheckout = lazy(() =>
  import('components/Philanthropy/MyGiving/Giving/GivingCheckout')
);
export const GivingReview = lazy(() =>
  import('components/Philanthropy/MyGiving/Giving/GivingReview')
);
export const GivingConfirmation = lazy(() =>
  import('components/Philanthropy/MyGiving/Giving/GivingConfirmation')
);
export const GivingTrafficController = lazy(() =>
  import('components/GivingTrafficController')
);
export const PledgePaymentCheckout = lazy(() =>
  import(
    '../components/Philanthropy/MyGiving/Pledges/Payments/PledgePaymentCheckout'
  )
);
export const PledgePaymentReview = lazy(() =>
  import(
    '../components/Philanthropy/MyGiving/Pledges/Payments/PledgePaymentReview'
  )
);
export const PledgePaymentConfirmation = lazy(() =>
  import(
    '../components/Philanthropy/MyGiving/Pledges/Payments/PledgePaymentConfirmation'
  )
);

// Event Registration
export const EventDetailsPage = lazy(() =>
  import('components/EventDetailsPage')
);
export const EventRegistrationContainer = lazy(() =>
  import('components/EventRegistration/EventRegistrationContainer')
);
export const GuestManagement = lazy(() =>
  import('components/EventRegistration/GuestManagement')
);
export const RegistrationOptionsForm = lazy(() =>
  import('components/EventRegistration/RegistrationOptionsForm')
);
export const EventRegistrationCheckpoint = lazy(() =>
  import('components/EventRegistration/EventRegistrationCheckpoint')
);
export const ReviewRegistration = lazy(() =>
  import('components/EventRegistration/ReviewRegistration')
);
export const AdditionalInfo = lazy(() =>
  import('components/EventRegistration/AdditionalInfo')
);
export const EventRegistrationContactInfo = lazy(() =>
  import('components/EventRegistration/EventRegistrationContactInfo')
);
export const EventConfirmation = lazy(() =>
  import('components/EventRegistration/EventConfirmation')
);
export const EventRegistrationUserIdentification = lazy(() =>
  import('components/EventRegistration/EventRegistrationUserIdentification')
);
export const NotInvited = lazy(() =>
  import('components/EventRegistration/NotInvited')
);
export const EventWaitlist = lazy(() =>
  import('components/EventRegistration/EventWaitlist')
);

// Miscellaneous
export const Volunteer = lazy(() => import('components/Volunteer'));
export const Scholarships = lazy(() => import('components/Scholarships'));
export const Settings = lazy(() => import('components/Settings'));
export const ContactUs = lazy(() => import('components/ContactUs'));

// Error Handling
export const Downtime = lazy(() => import('components/Downtime'));
export const NotFound = lazy(() => import('components/NotFound'));

// Internal Tools
export const StyleGuide = lazy(() => import('components/StyleGuide'));
export const ComponentLibrary = lazy(() =>
  import('components/ComponentLibrary')
);
